"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("vant/es/toast/style/less");

var _toast = _interopRequireDefault(require("vant/es/toast"));

var _axios = _interopRequireDefault(require("axios"));

// import qs from 'qs'
// create an axios instance
var service = _axios.default.create({
  baseURL: "".concat(location.protocol, "//").concat(process.env.VUE_APP_BASE_API),
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30 * 1000 // request timeout

}); // request interceptor


service.interceptors.request.use(function (config) {
  // console.log(config)
  // config.data = qs.stringify(config.data) // 所有post请求的参数data需要转化  不需要转化
  config.headers['headerParam'] = '{ "platform": "web"}';
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'; // 设置为json格式

  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug

  return Promise.reject(error);
}); // response interceptor

service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;

  if (res.retCode !== '0000') {
    // 状态码不为0000时发生请求错误
    (0, _toast.default)({
      message: res.retMsg || 'Error',
      duration: 5 * 1000
    });
    return Promise.reject(new Error(res.retMsg || 'Error'));
  } else {
    // 状态码为0000时成功返回
    // console.log('成功')
    return res;
  }
}, function (error) {
  // 请求不成功时
  // console.log('err' + error) // for debug
  // console.log(error.response) // for debug
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误(400)';
        break;

      case 401:
        error.message = '未授权，请重新登录(401)';
        break;

      case 403:
        error.message = '拒绝访问(403)';
        break;

      case 404:
        error.message = '请求出错(404)';
        break;

      case 408:
        error.message = '请求超时(408)';
        break;

      case 500:
        error.message = '服务器错误(500)';
        break;

      case 501:
        error.message = '服务未实现(501)';
        break;

      case 502:
        error.message = '网络错误(502)';
        break;

      case 503:
        error.message = '服务不可用(503)';
        break;

      case 504:
        error.message = '网络超时(504)';
        break;

      case 505:
        error.message = 'HTTP版本不受支持(505)';
        break;

      default:
        error.message = "\u8FDE\u63A5\u51FA\u9519(".concat(error.response.status, ")!");
    }
  } else {
    error.message = '连接服务器失败!';
  }

  (0, _toast.default)({
    message: error.message,
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
var _default = service;
exports.default = _default;